import ServiceProvider from '@/application/providers/ServicesProvider'
import Util from '@/application/libs/util';
import moment from 'moment'
import {validationFunctions as vf, validateFields, getFormatedError} from  '@/application/libs/validations'
import { t } from 'i18next'

const _getNumberFromLocalString = function(numberStr){
    if(numberStr !== undefined){
        numberStr = numberStr.replace(",", ".");
        numberStr[0] === '.' && (numberStr = '0' + numberStr);
    }
    return numberStr;
};

export default {
   

    /**
     * Setup all screen data. Get data to dinamicaly 
     * build grid.
     * 
     * @param {Object} controlContext
     */
    async initMonthServiceScreen(controlContext){
         /**
         * Array of changed objects ready to save.
         */
        this.toSaveData = [];
        
        this.servConfigData = await ServiceProvider.getMonthServConfig();
        controlContext.setupGridMonth(this.servConfigData[0], this.servConfigData[1]);
    },

    /**
     * Setup all screen data. Get data to dinamicaly 
     * build grid.
     * 
     * @param {Object} controlContext
     */
    async initServiceScreen(controlContext){
        /**
        * Array of changed objects ready to save.
        */
       this.toSaveData = [];
       
       this.servConfigData = await ServiceProvider.getServConfig();
       controlContext.setupGrid(this.servConfigData[0], this.buildMergedRows(this.servConfigData[1]));
   },

    /**
     * Merge row data to correct check icon location.
     * Change data to eliminate duplicates.
     * 
     * @param {Array} rowData
     */
    buildMergedRows(rowData){
        return rowData.reduce(function(accum, current){
            let existentIndex = accum.findIndex(row=>row.NRGRUPOPRATOSERV==current.NRGRUPOPRATOSERV);
            
            if(existentIndex === -1){
                current.NRSEQCNFCARD = [current.NRSEQCNFCARD];
                accum.push(current);
            } else {
                accum[existentIndex].NRSEQCNFCARD.push(current.NRSEQCNFCARD);
            }

            return accum;
        }, []);
    },

    /**
    * This function validates a given key and value and returns a result based on specific colum key.
    * 
    * @param {Object} key: Config key. 
    * @param {Object} value: Row data.
    */
    verifyColumKey(key, value){
        var resp;
        if(key === "IDUTILPERCENTCONS"){
           resp = value; 
        }else{
            resp = value === "S" ? value : "N";
        }
        return resp
    },
    /**
    * Save changes at No Preparation Mode, in values checked or no
    * 
    * @param {Object} column: Column data. 
    * @param {Object} row: Row data.
    * @param {Object} config: controller config
    */
    saveChange(column, row, config) {
        let saveObj = this.servConfigData[0].find(col => col.columnName === column.field);
        saveObj.NRORG = Util.getLocalVar('userData').NRORG;
        if(config.key === "VRPERCENTUALFIXO"){
            let rawValue = row[column.field] ? row[column.field].toString().replace(',', '.').trim() : "";
            let formattedValue;

            if (rawValue === "") {
                formattedValue = null;
            } else {
                let numValue = parseFloat(rawValue);
                if (numValue >= 1000 || numValue <= 0) {
                    Util.showErrorNotification({
                        title: t('error_saving'),
                        text: numValue >= 1000 ? t('value_must_be_less_than_1000') : t('value_must_be_higher_than_0')
                    });
                    return;
                }
                formattedValue = numValue.toFixed(2);
            }

            saveObj[config.key] = formattedValue;
        } else{
            saveObj[config.key] = this.verifyColumKey(config.key, row[column.field + '_key']);
        }
    
        ServiceProvider.saveData(saveObj, config.from).then(() => {
            Util.showNotification({
                text: t('save_as', { PARAM: `${moment().format('HH:mm:ss')}` }),
                title: config.successTitle
            });
        }, () => {
            Util.showErrorNotification({
                title: t('error_saving'),
                text: ''
            });
        });
    },

    async saveChangeOnControlMonthRow(data){
        if(data.NRCONFCARDMESATIVO != null) {
            await ServiceProvider.updateControlMonthRow(data).then(()=>{
                Util.showNotification({
                    text: t('save_as', {PARAM: `${moment().format('HH:mm:ss')}`}),
                    title: t('changed_percentage_source')
                });
                
            }, responseError=>{
                Util.showErrorNotification({
                    title: t('error_saving'),
                    text:''
                });
            });
        } else {
            await ServiceProvider.insertControlMonthRow(data).then(()=>{
                Util.showNotification({
                    text: t('save_as', {PARAM: `${moment().format('HH:mm:ss')}`}),
                    title: t('changed_percentage_source')
                });
            }, responseError=>{
                Util.showErrorNotification({
                    title: t('error_saving'),
                    text:''
                });
            });
        }
    },

    /**
     * Save changes in selected plates rows.
     * 
     * @param {Object} column Column data. 
     * @param {Object} row Row data.
     * @param {*} newValue New selected value.
     */
    saveChangeOnPlateRow(column, row, newValue){
        let saveObj = {};
        let confSeq = this.servConfigData[0].find(col=>col.columnName==column.field).NRSEQCNFCARD;

        saveObj.data = {
            NRGRUPOPRATOSERV: row.NRGRUPOPRATOSERV,
            NRSEQCNFCARD: confSeq
        };
        
        if(newValue){
            saveObj.operation = 'add';
        } else {
            saveObj.operation = 'del';
        }

        this.toSaveData.push(saveObj);
        this.saveQueuedChanges();
    },

    /**
     * Save all queued changes.
     */
    saveQueuedChanges: Util.debounce(function(){
        return ServiceProvider
            .saveSettingsChanges(this.toSaveData)
            .then(()=>{
                this.toSaveData = [];
                Util.showNotification({
                    text: t('save_as', {PARAM: `${moment().format('HH:mm:ss')}`}),
                    title: t('saved_data')
                });
            });
    }, 100),

    saveNewPortioningSet: function(data, colName) {
        data = {...data, VRCONJUNTOPORCAO: _getNumberFromLocalString(data.VRCONJUNTOPORCAO)};
        const validations = {
            NMGRTIPOPR: {f: vf.withAnother(vf.notEmpty, "CDGRTIPOPR", t('dish_type_group')), label: ""},
            CDGRTIPOPR: { f: vf.notEmpty, label: t('dish_type_group')},
            VRCONJUNTOPORCAO: { f: (data) => !isNaN(data.VRCONJUNTOPORCAO) && data.VRCONJUNTOPORCAO >= 0 &&
                 data.VRCONJUNTOPORCAO <= 999 && true || t('consumption_percentage_field_is_not_a_valid_percentage'), label: "" }
        };
        const validationResult = validateFields(data, validations);
        if(validationResult === true){
            return ServiceProvider.insertPortioningSet(data);
        } else {
            return Promise.reject(getFormatedError(data, validations, colName, true));
        }
    },

    updatePortioningSet: function({NRCONJUNTOPORCAO, VRCONJUNTOPORCAO}){
        if(!isNaN(VRCONJUNTOPORCAO) && VRCONJUNTOPORCAO >= 0 && VRCONJUNTOPORCAO <= 999){
            return ServiceProvider.updatePortioningSet({NRCONJUNTOPORCAO, VRCONJUNTOPORCAO});
        } else{
          return Promise.reject({error: t('consumption_percentage_field_is_not_a_valid_percentage')})  
        }
    },

    autoCalculateConsumptionPercentage(data){
        return ServiceProvider.autoCalculateConsumptionPercentage(data);
    },

    removePortioningSet: function(rows) {
        const NRCONJUNTOPORCAOArr = rows.map(r => ({NRCONJUNTOPORCAO: r.NRCONJUNTOPORCAO}));
        return ServiceProvider.removePortioningSet(NRCONJUNTOPORCAOArr);
    },

    getPlateGroup: function(query) {
        return ServiceProvider.getPlateGroup(query);
    },

    getPortioningSets: function() {
        return ServiceProvider.getPortioningSets();
    },

    saveNewDayOutRutSet: function(data, colName) {
        data = {
            ...data,
            QTCLIESTICAR: _getNumberFromLocalString(data.QTCLIESTICAR),
            QTDOAESTICAR: _getNumberFromLocalString(data.QTDOAESTICAR),
            QTFUNESTICAR: _getNumberFromLocalString(data.QTFUNESTICAR)
        };
        const validations = {
            QTCLIESTICAR: { f: (data) => !isNaN(data.QTCLIESTICAR) && data.QTCLIESTICAR > 0 &&
                data.QTCLIESTICAR <= 999999 && true || t('the_customer_diners_field_does_not_have_a_valid_value'), label: "" },
            QTDOAESTICAR: { f: (data) => !isNaN(data.QTDOAESTICAR) && data.QTDOAESTICAR >= 0 &&
                data.QTDOAESTICAR <= 999999 && true || t('the_diners_donation_field_does_not_have_a_valid_value'), label: "" },
            QTFUNESTICAR: { f: (data) => !isNaN(data.QTFUNESTICAR) && data.QTFUNESTICAR >= 0 &&
                data.QTFUNESTICAR <= 999999 && true || t('the_employee_diners_field_does_not_have_a_valid_value'), label: "" }
                    
        };
        const validationResult = validateFields(data, validations);
        if(validationResult === true){
            return ServiceProvider.insertDayOutRutSet(data);
        } else {
            return Promise.reject(getFormatedError(data, validations, colName, true));
        }
    },

    updateDaysOutRutSet: function(data, colName){
        data = {
            ...data,
            QTCLIESTICAR: _getNumberFromLocalString(data.QTCLIESTICAR),
            QTDOAESTICAR: _getNumberFromLocalString(data.QTDOAESTICAR),
            QTFUNESTICAR: _getNumberFromLocalString(data.QTFUNESTICAR)
        };
        const validations = {
            QTCLIESTICAR: { f: (data) => !isNaN(data.QTCLIESTICAR) && data.QTCLIESTICAR > 0 &&
                data.QTCLIESTICAR <= 999999 && true || t('the_customer_diners_field_does_not_have_a_valid_value'), label: "" },
            QTDOAESTICAR: { f: (data) => !isNaN(data.QTDOAESTICAR) && data.QTDOAESTICAR >= 0 &&
                data.QTDOAESTICAR <= 999999 && true || t('the_diners_donation_field_does_not_have_a_valid_value'), label: "" },
            QTFUNESTICAR: { f: (data) => !isNaN(data.QTFUNESTICAR) && data.QTFUNESTICAR >= 0 &&
                data.QTFUNESTICAR <= 999999 && true || t('the_employee_diners_field_does_not_have_a_valid_value'), label: "" }
                    
        };
        const validationResult = validateFields(data, validations);
        if(validationResult === true){
            return ServiceProvider.updateDaysOutRutSet(data);
        } else{
            return Promise.reject(getFormatedError(data, validations, colName, true));
        }
    },

    getDaysOutRutSets: function() {
        return ServiceProvider.getDaysOutRutSets();
    },

    removeDaysOutRutSet: function(rows) {
        const NRCARDIAEVENTOArr = rows.map(r => ({NRCARDIAEVENTO: r.NRCARDIAEVENTO}));
        return ServiceProvider.removeDaysOutRutSet(NRCARDIAEVENTOArr);
    },

    saveLinkTypeDishes: function(data, colName) {
        data = {...data};
        const validations = {
            NMTIPOPRATORIG: {f: vf.withAnother(vf.notEmpty, "CDTIPOPRATORIG", "Tp. Prato Origem"), label: ""},
            CDNMSERVORIG: {f: vf.withAnother(vf.notEmpty, "CDSERVFILI", "Serviço Origem"), label: ""},
            NMTIPOPRAT: {f: vf.withAnother(vf.notEmpty, "CDTIPOPRAT", "Tp. Prato Destino"), label: ""},
        };

        const validationResult = validateFields(data, validations);
        if(validationResult === true){
            return ServiceProvider.insertLinkTypeDishes(data);
        } else {
            return Promise.reject(getFormatedError(data, validations, colName, true));
        }
    },

    getLinkTypeDishes: function() {
        return ServiceProvider.getLinkTypeDishes();
    },

    getDestineDishes: function() {
        return ServiceProvider.getDestineDishes();
    },

    getFilial: function() {
        return ServiceProvider.getFilial();
    },

    getOriginDishes: function(data) {
        let cdfilial = data.CDFILIALORIG ? data.CDFILIALORIG : data.FILIAL_key;
        let cdservfili = data.CDSERVORIG ? data.CDSERVORIG : data.CDNMSERVORIG_key;
        return ServiceProvider.getOriginDishes(cdfilial, cdservfili);
    },

    getServOri: function() {
        return ServiceProvider.getServOri();
    },
    
    getServByUnit: function(params) {
        return ServiceProvider.getServByUnit(params);
    },

    removeLinkTypeDishes: function(rows) {
        const NRTIPOPRATCOMUMSERVArr = rows.map(r => ({NRTIPOPRATCOMUMSERV: r.NRTIPOPRATCOMUMSERV}));
        return ServiceProvider.removeLinkTypeDishes(NRTIPOPRATCOMUMSERVArr);
    },

    generateLists: function(objects) {
        return ServiceProvider.generateLists(objects);
    },

    saveExportConfCard: function(FILISERV, TABLE, ITEMS, MODE, PLATEGRID) {
        return ServiceProvider.saveExportConfCard(FILISERV, TABLE, ITEMS, MODE, PLATEGRID);
    },

    deleteLists: function(arrList) {
        return ServiceProvider.deleteLists(arrList);
    },

    deleteOverlap: function(filiserv) {
        return ServiceProvider.deleteOverlap(filiserv);
    },

    insertExportData: function(filiserv, listday) {
        return ServiceProvider.insertExportData(filiserv, listday);
    }
}